import { render, staticRenderFns } from "./GlyphComponent.vue?vue&type=template&id=e89267a6&scoped=true&"
import script from "./GlyphComponent.vue?vue&type=script&lang=js&"
export * from "./GlyphComponent.vue?vue&type=script&lang=js&"
import style0 from "./GlyphComponent.vue?vue&type=style&index=0&id=e89267a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89267a6",
  null
  
)

export default component.exports